export default "__VITE_ASSET__CUa0Jtqp__"